import {
    SET_CURRENT_USER, SET_APP_MENU, SET_BASE_URL, SET_MYKOMATSU_BASE_URL, SET_CART_COUNT,
    SET_MYKOMATSU_REGION, SET_KOMATSU_CARE_BROCHURES, SET_MAP_CENTER, SET_APP_LINK, SET_IS_MINEXPO_ENABLED
} from './types';
 
const setCurrentUser = (currentuser:any) => ({
  type: SET_CURRENT_USER,
  currentuser
})

const setBaseUrl = (imgbaseUrl:any) => ({
  type: SET_BASE_URL,
  imgbaseUrl
})


const setAppMenus = (appmenus: any) => ({
    type: SET_APP_MENU,
    appmenus
})

const setAppLinks = (applinks: any) => ({
    type: SET_APP_LINK,
    applinks
})

const setMyKomatsuBaseUrl = (myKomatsuBaseUrl: any) => ({
    type: SET_MYKOMATSU_BASE_URL,
    myKomatsuBaseUrl
})

const setCartCount = (cartCount: any) => ({
    type: SET_CART_COUNT,
    cartCount
})

const setMyKomatsuRegion = (myKomatsuRegion: any) => ({
    type: SET_MYKOMATSU_REGION,
    myKomatsuRegion
})

const setKomatsuCareBrochures = (komatsuCareBrochures: any) => ({
    type: SET_KOMATSU_CARE_BROCHURES,
    komatsuCareBrochures
})

const setMapCenter = (mapCenter: any) => ({
    type: SET_MAP_CENTER,
    mapCenter
})

const setIsMinExpoEnabled = (isMinExpoEnabled: any) => ({
    type: SET_IS_MINEXPO_ENABLED,
    isMinExpoEnabled
})

export {
    setCurrentUser, setAppMenus, setBaseUrl, setMyKomatsuBaseUrl, setCartCount,
    setMyKomatsuRegion, setKomatsuCareBrochures, setMapCenter, setAppLinks, setIsMinExpoEnabled
};
  